import { Ng2StateDeclaration } from '@uirouter/angular';
import { AdminDashboardComponent } from '@client/app/feature-modules/admin/modules/admin-dashboard/components/admin-dashboard.component';

export const AdminDashboardStates: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.admin.dashboard',
        url: '/dashboard',
        component: AdminDashboardComponent,
        data: { title: 'Acquia Web Governance - Dashboard' },
    },
];
